import React, { useCallback, useEffect } from 'react'
import styled from 'styled-components'
import LPHeader from 'src/components/layout/Header/LPHeader'
import { useNavigate } from 'react-router-dom'
import StepsHeader from 'src/components/layout/Header/StepHeader'
import { HeaderStyle } from 'src/components/layout/Header/HeaderStyle'
import { PATH as PATH_AUTH } from 'src/pages/auth'
import LocalStorage from 'src/utils/LocalStorage'
import { LINE_STATUS } from 'src/constants/user'
import { useAppSelector } from 'src/store'
import liff from '@line/liff'
import { APP_LINE_OA_ID } from 'src/constants/env-constant'

const ContactMethodContainer: React.FC = () => {
  const navigate = useNavigate()
  const user = useAppSelector((state) => state.ui.app.authInfo)
  const isLineLinked = user?.line_status === LINE_STATUS.LINKED_AND_FOLLOWED

  const handleLineLink = useCallback(async () => {
    if (isLineLinked) return
    navigate(PATH_AUTH.LINE_LINK)
  }, [navigate, isLineLinked])

  const handleOpenLineChat = useCallback(() => {
    liff.openWindow({
      url: `https://line.me/R/ti/p/@${APP_LINE_OA_ID}`,
      external: true,
    })
  }, [])

  useEffect(() => {
    if (LocalStorage.getTelemedicine()) {
      LocalStorage.removeTelemedicine()
    }
  }, [])

  return (
    <Wrapper>
      <LPHeader />
      <div className="w-full justify-center mx-auto">
        <StepsHeader
          step={10}
          stepActiveName={'お問い合わせ'}
          className="top-70"
        />
        <div className="mt-70">
          <ContactHeader>以下のどちらかよりお問い合わせください</ContactHeader>
        </div>
      </div>
      <div className="w-full justify-center mx-auto register-form pl-20 pr-20">
        <Options>
          <OptionButton
            className="line"
            onClick={isLineLinked ? handleOpenLineChat : handleLineLink}
          >
            LINE
          </OptionButton>
          <OptionButton
            className="contact"
            onClick={() => navigate(PATH_AUTH.CONTACT)}
          >
            お問い合わせフォーム
          </OptionButton>
        </Options>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div``

const Options = styled.div`
  margin-top: 2rem;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

const OptionButton = styled.button`
  width: 100%;
  max-width: 300px;
  height: 65px;
  padding: 0.9rem 1rem;
  border-radius: 65px;
  background-color: #f5f3e9;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s ease;

  &.line {
    background-color: #02ab37;
  }

  &.contact {
    background-color: #545454;
  }

  &:disabled {
    background-color: #9e9e9e;
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:hover {
    opacity: 0.8;
  }
`

const ContactHeader = styled(HeaderStyle)`
  padding-left: 15px;

  /* Tablet */
  @media (max-width: 1024px) {
    font-size: 18px;
  }

  /* Mobile */
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.5;
  }
`

export default ContactMethodContainer
